import { useMemo } from 'react';

/**
 * Custom hook for treatment slot filter configuration
 * @returns {Array} Filter configuration for AdvancedTable
 */
export const useTreatmentSlotFilters = () => {
    return useMemo(() => [
        {
            id: 'status',
            label: 'Booking Status',
            type: 'select',
            options: [
                { value: 'Upcoming', label: 'Upcoming' },
                { value: 'Completed', label: 'Completed' },
                { value: 'Cancelled', label: 'Cancelled' },
                { value: 'InProgress', label: 'In Progress' },
            ],
            multiple: false,
            searchable: false,
        },
        {
            id: 'customerName',
            label: 'Customer Name',
            type: 'text',
            placeholder: 'Search by customer name...',
        },
        {
            id: 'treatmentName',
            label: 'Treatment Name',
            type: 'text',
            placeholder: 'Search by treatment name...',
        },
        {
            id: 'phoneNo',
            label: 'Phone Number',
            type: 'text',
            placeholder: 'Search by phone number...',
        },
        {
            id: 'dateRange',
            label: 'Date Range',
            type: 'dateRange',
            quickFilters: ['today', 'last7days', 'last30days', 'thisMonth', 'lastMonth'],
        },
    ], []);
};
